import { IPageHandler } from './pageHandler';
import { AnimatedForm } from '../widgets/animatedForm';

export class VideoLpHandler implements IPageHandler {
    public run(): void {
        this.actorSpriteInit();
        this.initAnimateFormByConfig();
    }

    private actorSpriteInit() {
        if (!window.app.config.landings.actorSpriteData || !window.app.config.landings.actorSpriteData) {
            console.log('Actor sprite is disabled');
            return;
        }

        const actorSpriteWidth = window.app.config.landings.actorSpriteData.actorSpriteWidth;
        const actorSpriteHeight = window.app.config.landings.actorSpriteData.actorSpriteHeight;
        const actorSpriteSteps = window.app.config.landings.actorSpriteData.actorSpriteSteps;
        const actorSpriteFrequency = window.app.config.landings.actorSpriteData.actorSpriteFrequency;

        /* inaccuracy - String value can be set from lp generator with - */
        const positioninaccuracyX = parseInt(window.app.config.landings.actorSpriteData.inaccuracyX) - 30;
        const positioninaccuracyY = parseInt(window.app.config.landings.actorSpriteData.inaccuracyY) + 10;

        const regFormPercentClass = '.vertical-middle-absolute';
        const regFromVhClass = '.vertical-middle-absolute-video-preloader';
        const $actorSpriteBlock:JQuery<HTMLElement> = $('.actor-sprite');
        const $registrationForm:JQuery<HTMLElement> = ($(regFormPercentClass).length) ? $(regFormPercentClass) : $(regFromVhClass);

        const leftOffsetRegForm = window.innerWidth / 10; // left offset of reg popup (10%)
        const topOffsetRegForm = window.innerHeight / 2 - actorSpriteHeight / 2; // top offset of reg popup (50%)

        const actorOffsetX = $registrationForm.width() + leftOffsetRegForm + positioninaccuracyX;
        const actorOffsetY = topOffsetRegForm + positioninaccuracyY;

        $actorSpriteBlock.width(actorSpriteSteps);
        $actorSpriteBlock.height(actorSpriteHeight);
        $actorSpriteBlock.css('left', actorOffsetX);
        $actorSpriteBlock.css('top', actorOffsetY);
        
        $actorSpriteBlock[0].animate([
            {backgroundPositionX: '0px'},
            {backgroundPositionX: `-${actorSpriteWidth}px`}
        ], {
            duration: 1000,
            easing: `steps(${actorSpriteFrequency})`,
            direction: 'alternate',
            iterations: Infinity
        });
    }

    private initAnimateFormByConfig() {
        if (!window.app.config.landings.animatedFormEnable) {
            console.log('Animated form is disabled');
            return;
        }

        AnimatedForm.spritesResizeAndPosingForm();
        $('.container__animated-form').css('visibility', 'hidden');
        window.addEventListener('resize', AnimatedForm.spritesResizeAndPosingForm);
        $('.container__animated-form--preview')[0].addEventListener('mousemove', AnimatedForm.startAnimatedForm.bind(this), {once: true});
    }
}
